import { render, staticRenderFns } from "./CommunityManager.vue?vue&type=template&id=da0df6c6&"
import script from "./CommunityManager.vue?vue&type=script&lang=js&"
export * from "./CommunityManager.vue?vue&type=script&lang=js&"
import style0 from "./CommunityManager.vue?vue&type=style&index=0&id=da0df6c6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports